import { MultipleDayBooleanInputs } from "./MultipleDayBooleanInputs";

export class PeriodDay {
    static attributePrefix = "PeriodDay";
    static attributePrefixDe = "Periodentag";
    
    static async getLastPeriods(){
        let ConcreteObj = new MultipleDayBooleanInputs('PeriodDay');
        return await ConcreteObj.getAllMyValues().then((res) => {
            console.log(res)
            let perioddays = [];
            for(var i= 0; i<res.length; i++){
                if((res[i].value.toString() == "true") && (res[i].valueTSto == 0)){
                    perioddays.push(res[i].valueTSfrom);
                }
            }
            console.log(perioddays);
        });
    }
}